module.exports = __webpack_public_path__ + "img/workOrder.26f1c939.svg";